import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { sequence1, sequence2, sequence3, sequence4, sequence5, sequence6 } from './timeline';
console.log(window.dimensions)
console.log(document.getElementById('scene-loading'))
console.log(document.getElementById('scene1preImage'))
gsap.registerPlugin(CustomEase);

window.gsap = gsap;
window.CustomEase = CustomEase;

window.prefill = window.prefill ?? {};

let s1, s2, s3, s4, s5, s6;

let isLocal = window.location.href.indexOf('obraz-pressure-campaign-2023-backend.test') > -1 ||
              window.location.href.indexOf('ngrok-free.app') > -1;

// Globální dimensions objekt — sdílený se všemi blade partial skripty
window.dimensions = {
    sceneWidth: 0,
    sceneHeight: 0,
    sceneRatio: 1,
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
    windowRatio: 1,
    small: true,
    medium: false,
};

/**
 * Přepočet rozměrů a aktualizace CSS proměnných.
 * Ekvivalent recheckDimensions() z Vue verze.
 */
function recheckDimensions() {
    const sceneEl = document.querySelector('.scene');
    if (!sceneEl) return;

    window.dimensions.windowWidth = window.innerWidth;
    window.dimensions.windowHeight = window.innerHeight;
    window.dimensions.windowRatio = Math.round(window.dimensions.windowWidth / window.dimensions.windowHeight * 100) / 100;

    // Fix pro mobilní klávesnici — pokud je focus na inputu, neměníme výšku
    const activeInput = document.querySelector('input:focus');
    if (activeInput) {
        document.documentElement.style.setProperty('--app-height', '100vh');
    } else {
        document.documentElement.style.setProperty('--app-height', `${window.dimensions.windowHeight}px`);
    }

    window.dimensions.sceneWidth = sceneEl.offsetWidth;
    window.dimensions.sceneHeight = sceneEl.offsetHeight;
    window.dimensions.sceneRatio = Math.round(window.dimensions.sceneWidth / window.dimensions.sceneHeight * 100) / 100;

    window.dimensions.small = window.dimensions.sceneRatio <= 1.5;
    window.dimensions.medium = !window.dimensions.small;

    sceneEl.classList.toggle('is-small', window.dimensions.small);
    sceneEl.classList.toggle('is-medium', window.dimensions.medium);

    // Notifikuje blade partial skripty (scene1, scene-pre atd.)
    window.dispatchEvent(new Event('dimensionsChanged'));
}

/**
 * Loader animace — kruh + texty.
 * Voláno před runAnimation(), aby loader běžel okamžitě.
 */
function initLoader() {
    // Animace textových zpráv
    const messagesTimeline = gsap.timeline({
        repeat: -1,
        defaults: {
            duration: 0.6,
            ease: "power1.inOut"
        }
    });

    const messageElements = document.querySelectorAll('.loader-message');
    messageElements.forEach((el) => {
        messagesTimeline
            .set(el, { display: 'block' })
            .to(el, { opacity: 1 })
            .to(el, { opacity: 0, delay: 1.5 })
            .set(el, { display: 'none' });
    });

    // Animace kruhu
    const circleTl = gsap.timeline();
    circleTl
        .to("#loader-circle", {
            duration: 3,
            strokeDashoffset: 100,
            ease: 'none',
        })
        .to("#loader-circle", {
            duration: 10,
            strokeDashoffset: 0,
            ease: CustomEase.create('loader-circle', 'M0,0 C0.126,0.382 0,0.978 0.698,0.988 0.726,0.988 0.818,1.001 1,1'),
        }, '-=.5');
}

/**
 * Inicializace všech animačních sekvencí a napojení na tlačítka.
 * Ekvivalent runAnimation() z Vue verze.
 */
function runAnimation() {
    s1 = sequence1();
    s2 = sequence2();
    s3 = sequence3();
    s4 = sequence4();
    s5 = sequence5();
    s6 = sequence6();

    // Automaticky spustí loader → zobrazí scénu 1
    s1.play();

    if (isLocal) {
        // Odkomentuj pro rychlé testování konkrétní sekvence:
        // s1.seek(10);
        // s2.play(); s2.seek(10);
        // s3.play(); s3.seek(10);
    }

    // Napojení tlačítek na přechody mezi scénami
    const bindClick = (id, seq) => {
        document.getElementById(id)?.addEventListener('click', () => seq.play());
    };

    bindClick('scene1prePlay', s2);
    bindClick('scene2prePlay', s3);
    bindClick('scene3prePlay', s4);
    bindClick('scene4prePlay', s5);
}

/**
 * Lifecycle
 */
window.addEventListener('resize', recheckDimensions);

window.addEventListener('load', () => {
    // Nejdřív přepočítej rozměry, pak spusť loader a animace
    recheckDimensions();
    initLoader();
    runAnimation();

    // Interval jako ve Vue verzi — záloha pro případy kdy resize event nestačí
    setInterval(recheckDimensions, 500);
});

// Exponuj globálně pro případ inline blade skriptů
window.runAnimation = runAnimation;
window.recheckDimensions = recheckDimensions;

// Alias pro openModal — scene1.blade.php volá window.openModal()
// openPopupByName je definována v app.js, tady jen vytvoříme alias až bude dostupná
window.addEventListener('DOMContentLoaded', () => {
    window.openModal = window.openPopupByName ?? function(name) {
        console.warn('openPopupByName není dostupná, popup:', name);
    };
});
